export default {
  code: 'fr', name: 'Francais', dir: 'ltr',
  nav: {
    dashboard: 'Tableau de bord', contacts: 'Contacts', companies: 'Entreprises', deals: 'Affaires',
    tasks: 'Taches', documents: 'Documents', procurement: 'Approvisionnement', workflows: 'Flux de travail',
    intelligence: 'Intelligence', marketplace: 'Marche', reports: 'Rapports', calendar: 'Calendrier',
    customFields: 'Champs personnalises', aiAssistant: 'Assistant IA', notifications: 'Notifications', settings: 'Parametres',
    schedule: 'Planifier & Rappeler',
  },
  common: {
    save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer', edit: 'Modifier', create: 'Creer', update: 'Mettre a jour',
    search: 'Rechercher', filter: 'Filtrer', export: 'Exporter', import: 'Importer', loading: 'Chargement...',
    noData: 'Aucune donnee disponible', confirm: 'Confirmer', back: 'Retour', next: 'Suivant', submit: 'Soumettre',
    yes: 'Oui', no: 'Non', all: 'Tout', none: 'Aucun', actions: 'Actions', status: 'Statut',
    name: 'Nom', email: 'E-mail', phone: 'Telephone', date: 'Date', type: 'Type', value: 'Valeur',
    description: 'Description', notes: 'Notes', close: 'Fermer', add: 'Ajouter', remove: 'Supprimer',
  },
  auth: {
    signIn: 'Se connecter', signOut: 'Se deconnecter', signUp: 'Creer un compte', welcome: 'Bienvenue',
    signInDesc: 'Connectez-vous a votre compte', createDesc: 'Commencez avec un compte gratuit',
    email: 'E-mail', password: 'Mot de passe', fullName: 'Nom complet', orContinueWith: 'Ou continuer avec',
    noAccount: "Pas de compte ?", hasAccount: 'Deja un compte ?',
    forgotPassword: 'Mot de passe oublie ?',
  },
  dashboard: {
    title: 'Tableau de bord', subtitle: 'Apercu des performances CRM',
    totalContacts: 'Total Contacts', companies: 'Entreprises', activeDeals: 'Affaires actives',
    pendingTasks: 'Taches en attente', pipelineValue: 'Valeur du pipeline', dealsBySector: 'Affaires par secteur',
    recentActivity: 'Activite recente',
  },
  deals: {
    title: 'Pipeline des affaires', addDeal: 'Ajouter une affaire', dealTitle: 'Titre', dealValue: 'Valeur',
    stage: 'Etape', probability: 'Probabilite', expectedClose: 'Date de cloture prevue',
    sector: 'Secteur', lead: 'Prospect', qualified: 'Qualifie', proposal: 'Proposition',
    negotiation: 'Negociation', closedWon: 'Gagne', closedLost: 'Perdu',
  },
  contacts: {
    title: 'Contacts', addContact: 'Ajouter un contact', firstName: 'Prenom', lastName: 'Nom',
    position: 'Poste', leadScore: 'Score du prospect', company: 'Entreprise', importCsv: 'Importer CSV',
  },
  companies: {
    title: 'Entreprises', addCompany: 'Ajouter une entreprise', industry: 'Industrie', website: 'Site web',
    city: 'Ville', country: 'Pays', size: 'Taille', annualRevenue: 'Revenu annuel',
  },
  tasks: {
    title: 'Taches', addTask: 'Ajouter une tache', dueDate: 'Date limite', priority: 'Priorite',
    pending: 'En attente', inProgress: 'En cours', completed: 'Termine', overdue: 'En retard',
    low: 'Basse', medium: 'Moyenne', high: 'Haute',
  },
  procurement: {
    title: 'Approvisionnement', newProcurement: 'Nouvel approvisionnement', budget: 'Budget',
    infrastructure: 'Infrastructure', energy: 'Energie', telecommunication: 'Telecommunication',
    logistic: 'Logistique', transports: 'Transports', services: 'Services',
  },
  bi: {
    title: 'Intelligence commerciale', weightedForecast: 'Prevision ponderee', totalPipeline: 'Pipeline total',
    winRate: 'Taux de reussite', crossSell: 'Ventes croisees', competitive: 'Analyse concurrentielle',
    businessUnits: 'Unites commerciales', clientAcquisition: 'Acquisition clients',
    revenueForecast: 'Prevision de revenus', conversionFunnel: 'Entonnoir de conversion',
  },
  audit: {
    title: 'Piste d\'audit', subtitle: 'Suivi de conformite et historique',
    action: 'Action', entity: 'Entite', user: 'Utilisateur', timestamp: 'Horodatage',
    changes: 'Modifications', ipAddress: 'Adresse IP', compliance: 'Conformite',
    exportLogs: 'Exporter les journaux', gdprLog: 'Journal RGPD', soxCompliance: 'Conformite SOX',
    totalLogs: 'Total des journaux',
  },
  settings: {
    title: 'Parametres', subtitle: 'Gerez votre compte et vos preferences',
    profile: 'Profil', appearance: 'Apparence', users: 'Utilisateurs', language: 'Langue',
    theme: 'Theme', darkMode: 'Mode sombre', lightMode: 'Mode clair',
    selectLanguage: 'Choisir la langue', languageDesc: 'Choisissez votre langue preferee',
  },
  marketing: {
    allProducts: 'Tous les produits',
    hero: 'BIL Business AI',
    heroSubtitle: "Menez une transformation mesurable avec des copilotes IA qui comprennent chaque transaction, document et fournisseur dans leur contexte — a travers votre CRM, vos data rooms et votre supply chain.",
    signIn: 'Se connecter',
    createAccount: 'Creer un compte gratuit',
    seePricing: 'Voir les offres et tarifs',
    language: 'Langue',
    nav: {
      overview: 'Vue d\'ensemble', products: 'Produits', solutions: 'Solutions',
      pricing: 'Tarifs', useCases: 'Cas d\'usage', partners: 'Partenaires', resources: 'Ressources', support: 'Support' ,
    },
    chips: {
      dataRooms: 'Data rooms', aiDealScoring: 'Scoring IA des deals',
      procurement: 'Achats', compliance: 'Conformite',
    },
    cards: {
      aiDealReadiness: 'Preparation IA des deals',
      dataRooms: 'Data rooms',
      grcAudit: 'GRC et Audit',
      workflowAI: 'Workflow IA',
      pipelineForecast: 'Prevision de pipeline',
      businessAI: 'Business AI',
      unifiedCopilot: 'COPILOTE UNIFIE',
    },
    productsMenu: {
      title: 'Pilotez chaque metier avec BIL.',
      blurb: 'Des applications concues pour chaque besoin, connectees par une meme trame de donnees et un copilote Business AI.',
      exploreAll: 'Explorer tous les produits',
      finance: 'Finance',
      financeDesc: 'Factures, budgets, journaux et P&L en temps reel.',
      procurement: 'Achats',
      procurementDesc: 'Source-to-pay, notation fournisseurs et appels d\'offres.',
      invest: 'Invest',
      investDesc: 'Place de marche pour acheter, vendre et encherir des entreprises.',
      supplyChain: 'Supply Chain',
      supplyChainDesc: 'Logistique, stocks et execution de bout en bout.',
      hr: 'Ressources Humaines',
      hrDesc: 'Collaborateurs, conges, performance et paie.',
      schedule: 'Planifier & Rappeler',
      scheduleDesc: 'Evenements simples avec rappels dans le navigateur — gratuit pour tous.',
    },
    solutionsMenu: {
      title: 'Des solutions sectorielles, pensees pour les resultats.',
      blurb: 'Preconfigurees pour la finance, le risque, les achats et le service — deployees en semaines, pas en trimestres.',
      exploreAll: 'Explorer toutes les solutions',
      erp: 'ERP', erpDesc: 'Finance, RH et operations unifiees sur une meme trame de donnees.',
      grc: 'GRC', grcDesc: 'Centre de controle gouvernance, risque, audit et conformite.',
      procurement: 'Achats', procurementDesc: 'Sourcing strategique, risque fournisseur et maitrise des depenses.',
      cx: 'Experience Client', cxDesc: 'CRM, service, marketing et fidelite dans un seul copilote.',
    },
  },
};
